var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhoneIconPhoneLanding(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 4V5.25H11.5V4H16.5Z",
    fill: "#474350"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 6.5H16.5V5.25H19V6.5Z",
    fill: "#474350"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.25 7.75V6.5H19V7.75H20.25Z",
    fill: "#474350"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 9H20.25V7.75H21.5V9Z",
    fill: "#474350"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.75 11.5V9H21.5V11.5H22.75Z",
    fill: "#474350"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.75 11.5H24V17.75H22.75V11.5Z",
    fill: "#474350"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.25 7.75V6.5H5.25V7.75H4V15.25H5.25V17.75H6.5V19H7.75V20.25H9V21.5H10.25V22.75H12.75V24H20.25V22.75H21.5V17.75H20.25V16.5H16.5V17.75H15.25V19H12.75V17.75H11.5V16.5H10.25V15.25H9V12.75H10.25V11.5H11.5V7.75H10.25ZM10.25 7.75V11.5H9V12.75H7.75V15.25H9V16.5H10.25V17.75H11.5V19H12.75V20.25H15.25V19H16.5V17.75H20.25V22.75H12.75V21.5H10.25V20.25H9V19H7.75V17.75H6.5V15.25H5.25V7.75H10.25Z",
    fill: "#474350"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 9V7.75H16.5V9H12.75Z",
    fill: "#474350"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M17.75 10.25H16.5V9H17.75V10.25Z",
    fill: "#474350"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M19 11.5H17.75V10.25H19V11.5Z",
    fill: "#474350"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M19 11.5H20.25V15.25H19V11.5Z",
    fill: "#474350"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIconPhoneLanding);
export default __webpack_public_path__ + "static/media/phone_icon_phone_landing.3a0b8613d767daae7d9fcf3886cdec46.svg";
export { ForwardRef as ReactComponent };